/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetConsigneeDeliveryNotesForToken } from '../../models/get-consignee-delivery-notes-for-token';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface GetConsigneeDeliveryNotesForToken$Params {
  token: Token64LengthType;
}

export function getConsigneeDeliveryNotesForToken(http: HttpClient, rootUrl: string, params: GetConsigneeDeliveryNotesForToken$Params, context?: HttpContext): Observable<StrictHttpResponse<GetConsigneeDeliveryNotesForToken>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeDeliveryNotesForToken.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetConsigneeDeliveryNotesForToken>;
    })
  );
}

getConsigneeDeliveryNotesForToken.PATH = '/organization-sites/consignee/delivery-notes/for-checkin';
